<br />
<img alt="Pioneer" class="system-logo" src="assets/images/logos/logo_transparent.png" />
<br />
<div class="login-container clearfix divider-content">
	<form #myForm (submit)="onSubmit()" [formGroup]="loginForm">
		<div class="row">
			<pcg-control-group class="col-sm-12" label="Username">
				<input pcgControlRef formControlName="userName" type="text" class="form-control" />
			</pcg-control-group>
		</div>
		<div class="row">
			<pcg-control-group class="col-sm-12" label="Password">
				<input pcgControlRef formControlName="password" type="password" class="form-control" />
			</pcg-control-group>
		</div>
		<button type="submit" class="btn btn-secondary btn-lg">Login</button>
		<a class="float-right" routerLink="/forgot-password">Forgot your password?</a>
	</form>
</div>
